import { render, staticRenderFns } from "./page-header-with-button.vue?vue&type=template&id=13ae89ec&"
import script from "./page-header-with-button.vue?vue&type=script&lang=js&"
export * from "./page-header-with-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports